import { render, staticRenderFns } from "./MultiRowCard.vue?vue&type=template&id=b985741c&"
import script from "./MultiRowCard.vue?vue&type=script&lang=js&"
export * from "./MultiRowCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports